import React from "react";
import "./AboutComp.css";
import { useEffect, useState } from "react";
import logo from "../../Assets/logo.png"

const AboutComp = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      imageUrl:
        "https://cdn.prod.website-files.com/5b044d009105d3778c5b7e1e/5b050dc1abbf2637bca31256_P1070397.jpg",
      alt: "image1",
    },
    {
      imageUrl:
        "https://cdn.prod.website-files.com/5b044d009105d3778c5b7e1e/5b044d84154674d7602b23dd_herobg02.jpg",
      alt: "image2",
    },
    {
      imageUrl:
        "https://cdn.prod.website-files.com/5b044d009105d3778c5b7e1e/5b050dc1a6d00b7a5aa06597_P1070707.jpg",
      alt: "image3",
    },
    {
      imageUrl:
        "https://cdn.prod.website-files.com/5b044d009105d3778c5b7e1e/5b050dc2fc1fa2023ee8bcc9_P1070744.jpg",
      alt: "image4",
    },
    {
      imageUrl:
        "https://cdn.prod.website-files.com/5b044d009105d3778c5b7e1e/5b050dc1a7ce347bc9a3c12c_P1070725.jpg",
      alt: "image5",
    },
  ];
  

  useEffect(() => {
    const interval = setInterval(() => {
      nextImage();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const nextImage = () => {
    setCurrentSlide((prevIndex) => (prevIndex + 1) % slides.length);
  };
  const prevImage = () => {
    setCurrentSlide(
      (prevIndex) => (prevIndex - 1 + slides.length) % slides.length
    );
  };
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="kryesorja-about">
      <div className="carouselabout">
        <img
          src={slides[currentSlide].imageUrl}
          alt={slides[currentSlide].alt}
        />

        <div className="indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`indicator ${currentSlide === index ? "active" : ""}`}
              onClick={() => goToSlide(index)}
            ></button>
          ))}
        </div>
        <div className="about-text">
          <h3>About Us</h3>
          <p>
            The Gentlemens Lounge offers traditional and modern haircuts and
            beard trims. Everyone is welcome in to the Gentlemens Lounge, we
            have all ages and walks of life come in and out of the shop. The
            shop opened on November 14th 2015 when ike Walmsley was 20 years
            old. We have 4 Gents cutting and trimming all day Tuesday –
            Saturday. Walk ins and appointments are available at the Gentlemens
            Lounge so we can cater for as many people as possible.
          </p>
          <span>-----</span>
          <p>
            On February 20th we opened up Gentlemens Lounge 2.0 upstairs above
            the current shop. This floor is kitted out a little bit different
            than downstairs. We have gone for an old era but more of a rustic
            theme. We have 2 chairs upstairs covering the overflow of the queue
            downstairs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutComp;
